module.exports = __webpack_public_path__ + "static/media/Avatars_Other-11.3655967e.png";